import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import baseURL from "../../configs/api";
import Cookies from 'js-cookie';
import colorConfigs from "../../configs/colorConfigs";
import { useTheme } from "../../components/hooks/useTheme";
import { Tabs } from "../../components/common/Tabs";
import axios from "axios";
import { VendorsList } from "./VendorsList";
import useTenant from "../../components/hooks/useTenant";

type TabType = {
    id: number,
    label: string
}

const filterItems = [
    {
        id: 0,
        label: "Vendor Name",
    },
]

export const Vendors = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { handleTenantError }: any = useTenant();
    const { themeStyles } = useTheme();
    const navigate = useNavigate();
    const [tabs, setTabs] = useState<TabType[]>([{
        id: 0,
        label: "All"
    }]);
    const savedTab = JSON.parse(
        sessionStorage.getItem("vendorsTab") || "{}"
    );

    const [activeIndex, setActiveIndex] = useState(
        savedTab.activeIndex ?? 0
    );

    const [currentIndex, setCurrentIndex] = useState(
        savedTab.currentIndex ?? 0
    );

    const [activeTabLable, setActiveTabLable] = useState(
        savedTab.activeTabLable ?? "All"
    );
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchValue, setSearchValue] = useState<string>("");
    const [vendorFilterValue, setVendorFilterValue] = useState(0);
    const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);

    useEffect(() => {
        axios
            .get(`${baseURL}location`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                    "Content-Type": "application/json"
                },
            })
            .then((response) => {
                response.data.forEach((item: any) => {
                    setTabs((tabs) => [
                        ...tabs,
                        {
                            id: item.id,
                            label: item.locationName,
                        },
                    ]);
                });
                handleTenantError(null);
            })
            .catch((error) => {
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleTabChange = (index: number, tab: any) => {
        setActiveIndex(tab?.id || index);
        setCurrentIndex(index);
        setActiveTabLable(tab?.label);
        sessionStorage.setItem(
            "vendorsTab",
            JSON.stringify({
                activeIndex: tab?.id || index,
                currentIndex: index,
                activeTabLable: tab?.label,
            })
        );
        setSearchValue("");
        setSelectedFilter(filterItems[0].label);
        setVendorFilterValue(0);
        setPaginationModel({
            page: 0,
            pageSize: 10,
        })
    }

    return (
        <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
            <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                <div className="flex items-center justify-end">
                    <div className="flex items-center gap-2.5">
                        <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                            onClick={() => navigate("/vendorsmanagement/vendors/addvendor")}
                        >
                            <span className="material-symbols-outlined text-[25px] font-light">
                                add
                            </span>
                            <span className="text-xs font-medium">Vendor</span>
                        </button>

                    </div>
                </div>
                <div className="w-full mt-2">
                    <Tabs tabs={tabs} onChange={(index, tab) => handleTabChange(index, tab)} activeIndex={currentIndex} />
                </div>

                <div>
                    <VendorsList
                        activeIndex={activeIndex}
                        activeTabLable={activeTabLable}
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        vendorFilterValue={vendorFilterValue}
                        setVendorFilterValue={setVendorFilterValue}
                        selectedFilter={selectedFilter}
                        setSelectedFilter={setSelectedFilter}
                        filterItems={filterItems}
                    />
                </div>
            </div>
        </div>
    );
}